import { useEffect, useState } from "react";
import { useToasts } from "react-toast-notifications";
import Button from "react-bootstrap/Button";
import currency from "currency.js";
import axios from 'axios';

const ExchangeRate = () => {
  const { addToast } = useToasts();
  const [state, setState] = useState({
    USD: 0,
    AUD: 0,
    isBusy: false,
    isSubmitted: false,
  })

  const handleSubmit = () => {
    setState({...state, isBusy: true});
    axios.get('/api/administration/exchange-rate/usd-aud', {
      params: {
        usdAmount: state.USD
      }
    }).then(res => {
      const data = res.data;
      setState({...state, isSubmitted: true, isBusy: false, AUD: data})
    }).catch(err => {
      console.log(err.response)
      setState({...state, isSubmitted: false, isBusy: false})
      addToast('Unable to get exchange rate', { appearance: 'error', autoDismiss: true });
    })
  }

  const handleChange = (key, value) => {
    setState({...state, [key]: value})
  }
  
  return (
    <div>
        <h3 className="mb-4">Exchange Rate</h3>
        <div className="w-25">
          <div className="mt-4">
            <div className="my-3 d-flex flex-row align-items-center">
              <p className="h6 mb-1 mr-2">Input USD Amount: </p>
              <input
                className="h6"
                type="number"
                style={{width: '20%'}}
                onChange={(e) => handleChange('USD', e.target.value)}
                value={state.USD}/>
            </div>
          </div>

          <Button
            variant="primary"
            disabled={state.isBusy || state.USD === 0}
            onClick={handleSubmit}>
            {state.isBusy ? "Submitting..." : "Submit"}
          </Button>

          {state.isSubmitted && (
            <div>
              <div className="my-3 d-flex flex-row align-items-center">
                <p className="h6 mb-1 mr-2">Amount in USD: </p>
                <p className="h6 mb-1 font-weight-bold">{currency(state.USD).format()}</p>
              </div>

              <div className="my-3 d-flex flex-row align-items-center">
                <p className="h6 mb-1 mr-2">Amount in AUD: </p>
                <p className="h6 mb-1 font-weight-bold">{currency(state.AUD).format()}</p>
              </div>
            </div>
          )}
        </div>
    </div>
  )
}

export default ExchangeRate;